module.exports = __webpack_public_path__ + "static/img/4815_phase_function_Paper_PointsHejduk_Prediction.126c924.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4815_phase_function_Paper_PointsHejduk_Prediction.png
// module id = r1je
// module chunks = 0